import React, { useState } from "react";
import { Form } from "antd";
import { Icon } from "@iconify/react";
import TextArea from "antd/es/input/TextArea";
import toast from "@comps/toast";
import { getErrorProps, makeRequest } from "@utils/helpers";
import { ButtonComponent, CancelButton, ModalComponent } from "@comps/components";
import { cancelCaseReq } from "../requests";

const formName = "cancelForm";

/**
 * Putting a case on hold: its initial data does not meet the
 * requirements, so it cannot be worked from as submitted.
 *
 * Wears the same shell as every other confirmation in the app (see
 * BaseConfirm) — an icon chip in the tone of the action, a title that
 * asks the question, and a commit button that repeats the verb. It is a
 * dialog rather than a plain confirm because this one needs a reason,
 * and the reason is what the other side reads.
 */
const CancelCaseComponent = (props) => {
  const [errors, setErrors] = useState([]);
  const [loader, setLoader] = useState(false);

  const rules = {
    reason: [{ required: true, message: "Say what does not meet the requirements" }],
  };

  const onFinish = (data) => {
    makeRequest(setLoader, cancelCaseReq, {
      id: props.caseid,
      reason: data.reason,
    }, onSuccess, onError);
  };

  const onSuccess = () => props.onSuccess();

  const onError = (data, res) => {
    setErrors(Array.isArray(data) ? { reason: data } : []);
    toast.error((res && res.msg) || "Unable to put this case on hold");
  };

  const footer = (
    <div className="form-actions">
      <CancelButton key="close_button" onClick={ () => props.handleCancel(false) } text="Not yet" />
      <ButtonComponent
        key="create_button"
        form={ formName }
        htmlType="submit"
        type="primary"
        state={ loader }
      >
        Put on hold
      </ButtonComponent>
    </div>
  );

  return (
    <ModalComponent
      className="base-modal confirm-modal confirm-modal--warning"
      icon="tabler:alert-triangle"
      mainTitle="Put this case on hold?"
      subTitle="The doctor is asked to fix the data before anyone works on it"
      open={ true }
      onCancel={ props.handleCancel }
      width="min(560px, calc(100vw - 32px))"
      footer={ footer }
    >
      <Form layout="vertical" name={ formName } onFinish={ onFinish }>
        <Form.Item
          name="reason"
          rules={ rules.reason }
          label="What does not meet the requirements?"
          className="da-mb-16"
          onChange={ () => setErrors([]) }
          { ...getErrorProps(errors['reason']) }
        >
          <TextArea rows={ 4 } placeholder="e.g. Lower arch scan is unreadable, cannot proceed" />
        </Form.Item>
      </Form>

      <p className="confirm-outcome">
        <Icon icon="tabler:arrow-narrow-right" width={ 17 } />
        <span>The case moves to On Hold until the doctor fixes the data.</span>
      </p>
    </ModalComponent>
  );
};

export default CancelCaseComponent;
